import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-email-text-v1',
    templateUrl: './fill-email-text-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillEmailTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Type a valid email here";
    public value: string = "";
    public valid: boolean = false;


    ngOnInit(): void {
        // Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.trim() !== '') {
            this.value = this.fieldSubmission.serialized_value;  // Set the value without triggering the input event
            this.valid = this.value.trim() !== ''; // Update validity
        } else {
            this.valid = !this.fieldSubmission.field.mandatory;
        }
        this.emitValidity();
    }

    onValueChange(value: string ) {
        this.value = value;
        // Email validation regex based on the RFC 5322 standard
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Check validity: No leading/trailing spaces and valid email format
        // when no mandatory: value set need to be empty or valid email to save
        this.valid = emailRegex.test(value.trim()) && value === value.trim() || (!this.fieldSubmission.field.mandatory && this.value === '');
        
        // console.log(" TExt email value----> ", value);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: value});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.valid});
    }

}
